<template>
    <li class="swiper-slide">
        <slot></slot>
    </li>
</template>

<script>
export default {
    name: 'swiper-slide'
};
</script>

<style scoped></style>
